<template>

  <div class="flex items-center gap-2 p-2 pt-4">

    <div class="mr-2">

      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="white"
        xmlns="http://www.w3.org/2000/svg"
        class="text-white"
      >

        <path
          d="M6.143 18.01v-2.625H3.4c-1.062 0-1.926-.92-1.926-2.05V7.418c0-1.13.864-2.05 1.926-2.05h12.27c1.063 0 1.927.92 1.927 2.05v5.917c0 1.13-.864 2.05-1.926 2.05v1.439c1.855 0 3.364-1.565 3.364-3.489V7.418c0-1.924-1.509-3.49-3.364-3.49H3.4c-1.856 0-3.366 1.566-3.366 3.49v5.917c0 1.924 1.51 3.489 3.365 3.489h1.306v2.55a.951.951 0 00.953.943.904.904 0 00.692-.323l2.678-3.17h2.673v-1.439h-3.34L6.143 18.01z"
        ></path>

        <path
          d="M28.6 11.683h-8.307v1.44H28.6c1.062 0 1.927.92 1.927 2.05v5.916c0 1.13-.864 2.05-1.927 2.05h-2.743v2.626l-2.218-2.625h-7.31c-1.061 0-1.925-.92-1.925-2.05v-5.917c0-1.13.864-2.05 1.926-2.05v-1.44c-1.855 0-3.365 1.566-3.365 3.49v5.916c0 1.925 1.51 3.49 3.365 3.49h6.64l2.68 3.17a.904.904 0 001.016.264.953.953 0 00.63-.886v-2.549H28.6c1.856 0 3.365-1.565 3.365-3.489v-5.916c0-1.924-1.509-3.49-3.365-3.49zM8.49 6.309l-2.545 6.704h1.493l.526-1.493h2.507l.507 1.493h1.53l-2.507-6.704H8.49zm-.14 4.113l.873-2.46h.018l.845 2.46H8.35z"
        ></path>

        <path
          d="M19.238 19.645c0 .735.47 1.212 1.236 1.212.92-.02 1.83-.604 2.127-.867.297-.265 1.095-1.182 1.447-1.909.446.211.657.564.657.954 0 .845-.814 1.334-2.112 1.483l.63.872c2.033-.266 2.725-1.12 2.725-2.37 0-1.057-.665-1.698-1.517-1.979.016-.077.044-.158.06-.237l-1.155-.205c-.008.116-.031.138-.054.255a4.644 4.644 0 00-1.024.07c0-.211.007-.775.015-.977.962-.04 1.908-.117 2.784-.25l-.102-1.142c-.9.18-1.767.274-2.62.321.024-.227.056-.87.056-.87l-1.22-.092c-.017.313-.024.68-.04 1-.54.008-1.18.008-1.517 0l.055 1.103h.133c.32 0 .845-.016 1.314-.031 0 .305.008.961.016 1.259-1.104.46-1.894 1.313-1.894 2.4zm3.676-1.767c-.165.328-.36.626-.579.875a11.859 11.859 0 01-.063-.805c.086-.015.43-.07.642-.07zm-1.72.453c.039.439.086.86.156 1.244a1.465 1.465 0 01-.58.172c-.39.016-.39-.234-.39-.344 0-.415.32-.798.813-1.072z"
        ></path>

      </svg>

    </div>

    <div v-for="(source, index) in this.sources" :key="source.id">

      <button
        class="border-0 capitalize h-auto py-2 btn btn-outline-white rounded-sm text-sm cursor-pointer font-medium px-4 whitespace-nowrap"
        type="button"
        @click="$emit('click', index)"
        :class="{ 'bg-white text-primary': current.id == source.id }"
      >
         {{ source.label }}
      </button>

    </div>

  </div>

</template>

<script>
export default {
  props: {
    sources: Array,
    current: Object
  }
};
</script>

